import { DateTime } from 'luxon';
import { Period } from '../../Period';
import { PartnerPlatform } from '../../PartnerPlatform/PartnerPlatform';
import { Pagination, paginationToParams } from '../../Pagination';

export interface ProductSalesReportFilter {
  startAt?: Date;
  endAt?: Date;
  period?: Period;
  productID?: number;
  optionValueID?: string;
  brandID?: number;
  platform?: PartnerPlatform;
  pagination?: Pagination;
}

export const getDefaultProductSalesReportFilter =
  (): ProductSalesReportFilter => ({
    startAt: DateTime.now().minus({ days: 30 }).toJSDate(),
    period: Period.DAY,
    pagination: {
      page: 0,
      pageSize: 10,
    },
  });

export const productSalesReportFilterToQueryParams = (
  filter: ProductSalesReportFilter,
) => ({
  'start-at': filter.startAt
    ? new Date(filter.startAt).toISOString()
    : undefined,
  'end-at': filter.endAt ? new Date(filter.endAt).toISOString() : undefined,
  period: filter.period,
  'product-id': filter.productID,
  'option-value-id': filter.optionValueID,
  'brand-id': filter.brandID,
  platform: filter.platform,
  ...(filter.pagination ? paginationToParams(filter.pagination) : {}),
});
